import React from "react";
import { ShieldCheck, Truck, Eye, Trash2, Clock, FileCheck, Lock, MapPin } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function AktenvernichtungVorOrt() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const highlights = [{
    title: "Datenvernichtung direkt vor Ort",
    description: "Wir kommen mit unserem Spezialfahrzeug direkt zu Ihnen. Die Vernichtung erfolgt auf einem LKW vor Ort.",
    icon: <Truck className="size-8 text-[var(--chart-3)]" />
  }, {
    title: "Verfahren nach Datenschutzvorgaben",
    description: "Unsere Maschinen ermöglichen eine sichere Vernichtung nach Datenschutzvorgaben und Sicherheitsstufe 3.",
    icon: <ShieldCheck className="size-8 text-[var(--chart-3)]" />
  }];
  const advantages = [{
    title: "Überwachung möglich",
    text: "Auf Wunsch können Sie die Durchführung der Datenvernichtung direkt vor Ort begleiten und überwachen",
    icon: <Eye className="size-6" />
  }, {
    title: "Keine Anfahrtskosten",
    text: "Die anschließende Entsorgung des Materials übernehmen wir direkt mit",
    icon: <MapPin className="size-6" />
  }, {
    title: "Entsorgung inklusive",
    text: "Wir übernehmen den Ablauf vor Ort, damit Ihnen mehr Zeit für wichtigere Aufgaben bleibt",
    icon: <Trash2 className="size-6" />
  }, {
    title: "Enorme Zeitersparnis",
    text: "Wir übernehmen den Ablauf vor Ort, damit Ihnen mehr Zeit für wichtigere Aufgaben bleibt",
    icon: <Clock className="size-6" />
  }];
  return <section id="aktenvernichtung-vor-ort" ref={ref} className="bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] bg-[var(--chart-3)]/5 rounded-full blur-3xl" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] bg-[var(--primary)]/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        {}
        <div className={cn("max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[var(--chart-3)]/10 text-[var(--chart-3)] text-sm font-medium mb-6">
            <Lock className="size-4" />
            <span>Sicherheit & Datenschutz</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6">
            Mobile Aktenvernichtung vor Ort
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">Vertrauliche Dokumente erfordern einen sicheren Umgang. Mit unserer mobilen Aktenvernichtung erfolgt die Datenvernichtung direkt bei Ihnen vor Ort – effizient, sicher und nachvollziehbar.</p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
          {highlights.map((item, i) => <div key={i} data-index={i} className={cn("transition-all duration-700 ease-out delay-100 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
          transitionDelay: `${100 + i * 150}ms`
        }}>
              <Card className="h-full border-l-4 border-l-[var(--chart-3)] bg-card/50 backdrop-blur-sm hover:shadow-lg transition-shadow duration-300">
                <CardHeader>
                  <div className="mb-4 p-3 bg-background w-fit rounded-lg shadow-sm border border-border/50">
                    {item.icon}
                  </div>
                  <CardTitle className="text-xl md:text-2xl text-foreground">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground">
                    {item.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {advantages.map((adv, i) => <div key={i} data-index={i} className={cn("flex flex-col items-start gap-4 p-6 rounded-xl bg-secondary/30 border border-border/50 transition-all duration-700 ease-out delay-300 transform hover:bg-secondary/50", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
          transitionDelay: `${300 + i * 100}ms`
        }}>
              <div className="p-2.5 rounded-lg bg-[var(--primary)] text-primary-foreground shadow-sm">
                {adv.icon}
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-2">
                  {adv.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {adv.text}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}